import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { ConnectStores } from "lib/core/store"
import "./PathListAppend.css"
import PathListPaste from "./PathListPaste"
import PathGroupFormContainer from "./group/PathGroupFormContainer"

const PathListAppend = function ({
  lesson_prompt,
  order,
  is_editing,
  selectNewLesson,
  unSelectPathItem
}) {
  let className = "PathListAppend"
  if (is_editing) {
    className += " PathListAppend--editing"
  }

  return (
    <div className={className}>
      {is_editing ? (
        <PathGroupFormContainer
          actionLabel="Create Lesson"
          onCancel={unSelectPathItem}
        />
      ) : (
        <div className="PathListAppend__Button">
          <Button
            className="PathListAppend__Add"
            styleType="secondary"
            size="large"
            onClick={selectNewLesson}
            inverted={true}
            stretch={true}
            rounded={false}
          >
            <Pathicon icon="plus-circle" />
            <span> </span>
            {lesson_prompt}
          </Button>
          <PathListPaste order={order} size={75} type="G" />
        </div>
      )}
    </div>
  )
}

const mapStateToProps = function (state, ownProps) {
  const { items } = state.pathStore.state
  const { selection, pasting_selection } = state.pathAdminStore.state
  const { selectNewPathItem, unSelectPathItem } = state.pathAdminStore.action

  const order = ownProps.order
  const is_editing =
    selection &&
    !selection.id &&
    !selection.parent &&
    selection.order === order &&
    !pasting_selection
  const hasItems = (items != null ? items.length : undefined) > 0
  const lesson_prompt = hasItems
    ? "Add another lesson"
    : "Add your first lesson"

  const selectNewLesson = function () {
    const data = {
      item_type: "G",
      order
    }
    return selectNewPathItem(data)
  }

  return _.assign(
    {},
    {
      // state
      items,
      order,
      selection,
      is_editing,
      lesson_prompt,
      // actions
      selectNewLesson,
      unSelectPathItem
    }
  )
}

const stores = [
  { store: "path", watch: false },
  { store: "pathAdmin", watch: ["selection", "pasting_selection"] }
]

PathListAppend.displayName = "PathListAppend"
export default ConnectStores(PathListAppend, stores, {}, mapStateToProps)
